module.exports = __webpack_public_path__ + "static/media/8_r_ybloko_55.26_94_07.44d861b6.png";